import React, { Component } from "react";
import styled from "styled-components";

const UpArrow = require("../../../../assets/imgs/upArrow.png");
const DownArrow = require("../../../../assets/imgs/downArrow.png");
const MainWrapper = styled.div`
  position:relative;
  width:285px;


  
  }
`;
const TooltipText = styled.span`
  visibility: hidden;
  width: 160px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
  &:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
`;
const Tooltip = styled.div`
  position: relative;
  cursor: pointer;
  display: inline-block;
  padding: 0px 4px;
  font-weight: bold;
  margin: 4px 5px;
  border-radius: 100%;
  border: 1px solid gray;
  color: gray;
  width: 15px;
  height: 15px;
  &:hover ${TooltipText} {
    visibility: visible;
  }
`;
const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 34px;
  :before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`;
const SlaveInput = styled.input`
  :checked + ${Slider} {
    background-color: #1b9f4e;
  }
  :focus + ${Slider} {
    box-shadow: 0 0 1px #1b9f4e;
  }
  :checked + ${Slider}::before {
    transform: translateX(18px);
  }
`;
const Toggle = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;

  ${SlaveInput} {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;
const CardContainer = styled.div`
  background: white;
  /* box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24); */
  // box-shadow: 0 4px 4px rgba(0,0,0,0.12), 0 4px 2px rgba(0,0,0,0.12);
  // border-radius: 5px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  border: none;
  padding: 10px;
  margin-bottom: 16px;
`;
const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  padding: 10px 0px;
  //background: red;
`;
const Title = styled.div`
  display: flex;
`;
const CardTitle = styled.div`
  font-weight: bold;
  padding: 3px 0px;
  font-size: 13px;
`;

const CardLimitAccordion = styled.div`
position: relative;
margin: 0px 12px;


& .upArrow {
  height: 30px;
  width: 30px;
  position: absolute;
  top: 10px;
  right:1;
 background: url('${UpArrow}');
 // background: red;
  background-repeat: no-repeat;
  cursor:pointer;
}

& .downArrow {

  height: 30px;
  width: 30px;
  position: absolute;
  top: 10px;
  right:1;
  background: url('${DownArrow}');
  //background: red;
  background-repeat: no-repeat;
  cursor:pointer;



`;

const CardLimitSlider = styled.div`
  height: auto;
  width: 100%;
  background: #f4f4f4;
  margin: 16px 0px;
  border-radius: 10px;

  .cardSliderContainer {
    width: 242px;
    margin: 4px 10px;
  }
  .cardSlider {
    -webkit-appearance: none;
    width: 100%;
    height: 4px;
    border-radius: 5px;
    background: #d3d3d3;
    outline: none;
    -webkit-transition: 0.2s;
    transition: opacity 0.2s;
    cursor: pointer;
  }
  .cardSlider:hover {
    background: #c0c0c0;
  }

  .cardSlider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #800000;
    border: 8px solid #fff;
    cursor: pointer;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  }
  .cardSlider::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #4caf50;
    cursor: pointer;
  }
`;

class DebitCardSettings extends Component {
  constructor(props) {
    super(props);
    this.originalCardData = [];
    this.originalTotals = { current: "0", max: "0" };
    this.state = {
      cardData: [],
      previousToggle: "",
      showButton: false,
      activeAccordian: 0,
      setLimits: [],
      totalCreditCurrentLimit: "0",
      totalCreditMaxLimit: "0",
      transactionMode: "",
    };

    this.handleCardLimitSlider = this.handleCardLimitSlider.bind(this);
  }

  formatAmount(value) {
    const source = value === null || value === undefined ? "0" : value;
    return String(source).replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  }
  parseNumeric(value, fallback = 0) {
    const numeric = Number(value);
    return Number.isNaN(numeric) ? fallback : numeric;
  }

  clampValue(value, min, max) {
    const normalizedMin = Number.isNaN(Number(min)) ? 0 : Number(min);
    const normalizedMaxCandidate = Number.isNaN(Number(max))
      ? normalizedMin
      : Number(max) < normalizedMin
      ? normalizedMin
      : Number(max);
    const numeric = Number(value);
    if (Number.isNaN(numeric)) {
      return normalizedMin;
    }
    if (numeric < normalizedMin) {
      return normalizedMin;
    }
    if (numeric > normalizedMaxCandidate) {
      return normalizedMaxCandidate;
    }
    return numeric;
  }
  componentDidMount() {
    // console.log(this.state.cardData)
    // console.log(this.props.cardData)

    //console.log(this.props.transactionMode)
    if (this.props.transactionMode == "International Transactions") {
      this.setState({
        transactionMode: "INTERNATIONAL",
      });
    }
    if (this.props.transactionMode == "Domestic Transactions") {
      this.setState({
        transactionMode: "DOMESTIC",
      });
    }

    const normalizedCardData = (this.props.cardData || []).map((data) => {
      const hasDailyLimits =
        Object.prototype.hasOwnProperty.call(data, "minLimit_Daily") ||
        Object.prototype.hasOwnProperty.call(data, "maxLimit_Daily");
      const dailyLimitSource =
        data.maxLimit_Daily !== undefined && data.maxLimit_Daily !== null
          ? data.maxLimit_Daily
          : data.currentLimit || data.maxLimit || "0";
      const perTxnLimitSource =
        data.maxLimit_Per !== undefined && data.maxLimit_Per !== null
          ? data.maxLimit_Per
          : data.maxLimit || dailyLimitSource;
      const hasPerLimits =
        Object.prototype.hasOwnProperty.call(data, "minLimit_Per") ||
        Object.prototype.hasOwnProperty.call(data, "maxLimit_Per");
      return {
        ...data,
        toggle_status: data.toggle_status === true,
        currentLimit: String(data.currentLimit || dailyLimitSource || "0"),
        currentLimitDaily: hasDailyLimits
          ? String(data.currentLimit_Daily || data.currentLimit || dailyLimitSource || "0")
          : null,
        currentLimitPer: hasPerLimits
          ? String(data.currentLimit_Per || data.currentLimit || perTxnLimitSource || "0")
          : null,
        originalCurrentLimitDaily: hasDailyLimits
          ? String(data.currentLimit_Daily || data.currentLimit || dailyLimitSource || "0")
          : null,
        originalCurrentLimitPer: hasPerLimits
          ? String(data.currentLimit_Per || data.currentLimit || perTxnLimitSource || "0")
          : null,
        maxLimit_Daily: hasDailyLimits
          ? String(dailyLimitSource)
          : null,
        maxLimit_Per: hasPerLimits
          ? String(perTxnLimitSource)
          : null,
        minLimit_Daily: hasDailyLimits
          ? String(data.minLimit_Daily || data.minLimit || "0")
          : null,
        minLimit_Per: hasPerLimits ? String(data.minLimit_Per || "0") : null,
        hasPerLimits,
        hasDailyLimits,
      };
    });

    this.originalCardData = normalizedCardData.map((data) => ({ ...data }));

    const toggleSnapshot = normalizedCardData.map((item) =>
      item.toggle_status === true ? "Y" : "N"
    );

    const limits = normalizedCardData.map((item) => ({
      limit: item.hasDailyLimits
        ? String(
              item.currentLimitDaily ||
              item.currentLimit ||
              "0"
          )
        : null,
      daily: item.hasDailyLimits
        ? String(
              item.currentLimitDaily ||
              item.currentLimit ||
              "0"
          )
        : null,
      per: item.hasPerLimits
        ? String(item.currentLimitPer || "0")
        : null,
    }));

    const currentCreditLimit = this.props.currentCreditLimit
      ? String(this.props.currentCreditLimit)
      : "0";
    const totalCreditLimit = this.props.totalCreditLimit
      ? String(this.props.totalCreditLimit)
      : "0";

    this.originalTotals = {
      current: currentCreditLimit,
      max: totalCreditLimit,
    };

    this.setState({
      setLimits: limits,
      totalCreditCurrentLimit: currentCreditLimit,
      totalCreditMaxLimit: totalCreditLimit,
      cardData: normalizedCardData.map((data) => ({ ...data })),
      previousToggle: toggleSnapshot.join(""),
    });
  }

  handleAccordionClickState = (cardId) => {
    if (cardId == this.state.activeAccordian) {
      this.setState({
        activeAccordian: 0,
      });
    } else {
      this.setState({
        activeAccordian: cardId,
      });
    }
  };

  handleResetSettings() {
    this.restoreOriginalState(true);
  }

  restoreOriginalState = (shouldShowButton = false) => {
    const restoredData = this.originalCardData.map((data) => ({ ...data }));
    const restoredLimits = restoredData.map((data) => ({
      limit: data.hasDailyLimits
        ? String(
              data.currentLimitDaily ||
              data.currentLimit ||
              "0"
          )
        : null,
      daily: data.hasDailyLimits
        ? String(
              data.currentLimitDaily ||
              data.currentLimit ||
              "0"
          )
        : null,
      per: data.hasPerLimits
        ? String(data.currentLimitPer || "0")
        : null,
    }));
    const toggleSnapshot = restoredData.map((item) =>
      item.toggle_status === true ? "Y" : "N"
    );

    this.setState({
      cardData: restoredData,
      setLimits: restoredLimits,
      previousToggle: toggleSnapshot.join(""),
      showButton: shouldShowButton,
      totalCreditCurrentLimit: this.originalTotals.current,
      totalCreditMaxLimit: this.originalTotals.max,
      activeAccordian: 0,
    });
  };

  hasLimitDifferences = (cardList, limitsSnapshot) => {
    const limits = limitsSnapshot || this.state.setLimits;
    return cardList.some((card, index) => {
      const original = this.originalCardData[index];
      if (!original) {
        return false;
      }
      if (original.hasDailyLimits) {
        const currentDaily =
          limits[index] && limits[index].daily != null
            ? String(limits[index].daily)
            : String(card.currentLimitDaily || card.currentLimit || "0");
        const originalDaily = String(
          original.currentLimitDaily ||
            original.currentLimit ||
            original.maxLimit_Daily ||
            "0"
        );
        if (currentDaily !== originalDaily) {
          return true;
        }
      }
      if (original.hasPerLimits) {
        const currentPer = limits[index] && limits[index].per != null
          ? String(limits[index].per)
          : String(card.currentLimitPer || "0");
        const originalPer = String(
          original.maxLimit_Per || original.currentLimitPer || "0"
        );
        if (currentPer !== originalPer) {
          return true;
        }
      }
      return false;
    });
  };

  handleTotalCreditSlider(event) {
    this.setState({
      totalCreditCurrentLimit: event.target.value,
      showButton: true,
    });

    //console.log(this.state.totalCreditCurrentLimit)
  }

  handleCardLimitSlider(event, cardId, cardIndex, sliderType) {
    const newValue = String(event.target.value);
    const targetIndex = cardIndex;
    const items = [...this.state.setLimits];
    const currentLimits = items[targetIndex]
      ? { ...items[targetIndex] }
      : { daily: null, per: null, limit: null };

    if (sliderType === "daily") {
      currentLimits.daily = newValue;
      currentLimits.limit = newValue;
    } else if (sliderType === "per") {
      currentLimits.per = newValue;
    }

    items[targetIndex] = currentLimits;

    const updatedCardData = this.state.cardData.map((card, index) => {
      if (index === cardIndex) {
        const updatedCard = { ...card };
        if (sliderType === "daily") {
          updatedCard.currentLimit = newValue;
          updatedCard.currentLimitDaily = newValue;
        } else if (sliderType === "per") {
          updatedCard.currentLimitPer = newValue;
        }
        return updatedCard;
      }
      return { ...card };
    });

    const toggleSnapshot = updatedCardData.map((value) =>
      value.toggle_status === true ? "Y" : "N"
    );
    const hasToggleChanges = toggleSnapshot.join("") !== this.state.previousToggle;
    const hasLimitChanges = this.hasLimitDifferences(updatedCardData, items);
    const hasCreditChange =
      String(this.state.totalCreditCurrentLimit) !== this.originalTotals.current;
    const shouldShowButton =
      hasToggleChanges || hasLimitChanges || hasCreditChange;

    this.setState({
      setLimits: items,
      cardData: updatedCardData,
      showButton: shouldShowButton,
    });
  }

  handleToggle = (cardId) => {
    const updatedData = this.state.cardData.map((card) => {
      if (card.cardId === cardId) {
        return { ...card, toggle_status: !card.toggle_status };
      }
      return { ...card };
    });
    const toggleSnapshot = updatedData.map((value) =>
      value.toggle_status === true ? "Y" : "N"
    );
    const hasToggleChanges = toggleSnapshot.join("") !== this.state.previousToggle;
    const hasLimitChanges = this.hasLimitDifferences(updatedData);
    const hasCreditChange =
      String(this.state.totalCreditCurrentLimit) !== this.originalTotals.current;

    this.setState({
      cardData: updatedData,
      showButton: hasToggleChanges || hasLimitChanges || hasCreditChange,
    });
  };

  handleChanges = () => {
    document.querySelector(".manage-credit-card-sf").style.pointerEvents =
      "none";
    document.querySelector(".manage-credit-card-sf").style.opacity = "0.8";

    // Build flat payload expected by backend
    const resolveCategoryKey = (title = "") => {
      const t = String(title).toLowerCase();
      if (t.includes("atm")) return "atm";
      if (t.includes("pos") || t.includes("merchant")) return "pos";
      if (t.includes("ecom") || t.includes("online") || t.includes("e-comm") || t.includes("e-commerce")) return "ecom";
      if (t.includes("contact") || t.includes("tap") ||  t.includes("pay")) return "contactless";
      return null;
    };

    const payload = {
      ecomDaily: "0",
      ecomPer: "0",
      atmDaily: "0",
      atmPer: "0",
      posDaily: "0",
      posPer: "0",
      contactlessLimit: "0",
      atm: "N",
      pos: "N",
      ecom: "N",
      contactless: "N",
    };

    this.state.cardData.forEach((data, index) => {
      const key = resolveCategoryKey(data.title);
      if (!key) return;

      const limitEntry = this.state.setLimits[index] || {};
      const hasStoredDaily = limitEntry.daily !== undefined && limitEntry.daily !== null;
      const hasLegacyLimit = limitEntry.limit !== undefined && limitEntry.limit !== null;

      // Daily limits
      let dailyVal = 0;
      if (data.hasDailyLimits) {
        const dailyMin = this.parseNumeric(data.minLimit_Daily || data.minLimit || "0", 0);
        const dailyMaxRaw = this.parseNumeric(
          data.maxLimit_Daily ||
            data.currentLimitDaily ||
            data.currentLimit ||
            dailyMin,
          dailyMin
        );
        const dailyMax = dailyMaxRaw < dailyMin ? dailyMin : dailyMaxRaw;
        const dailySource =
          hasStoredDaily
            ? String(limitEntry.daily)
            : hasLegacyLimit
            ? String(limitEntry.limit)
            : String(
                data.currentLimitDaily ||
                  data.currentLimit ||
                  data.maxLimit_Daily ||
                  "0"
              );
        dailyVal = this.clampValue(dailySource, dailyMin, dailyMax);
      }

      // Per-transaction limits
      let perVal = 0;
      if (data.hasPerLimits) {
        const perMin = this.parseNumeric(data.minLimit_Per || "0", 0);
        const perMaxRaw = this.parseNumeric(
          data.maxLimit_Per || data.currentLimitPer || perMin,
          perMin
        );
        const perMax = perMaxRaw < perMin ? perMin : perMaxRaw;
        const perSource = String(
          limitEntry.per ||
            data.currentLimitPer ||
            data.maxLimit_Per ||
            data.maxLimit ||
            "0"
        );
        perVal = this.clampValue(perSource, perMin, perMax);
      }

      const toggleStr = data.toggle_status ? "Y" : "N";

      switch (key) {
        case "atm":
          payload.atm = toggleStr;
          payload.atmDaily = String(dailyVal);
          payload.atmPer = String(perVal);
          break;
        case "pos":
          payload.pos = toggleStr;
          payload.posDaily = String(dailyVal);
          payload.posPer = String(perVal);
          break;
        case "ecom":
          payload.ecom = toggleStr;
          payload.ecomDaily = String(dailyVal);
          payload.ecomPer = String(perVal);
          break;
        case "contactless":
          payload.contactless = toggleStr;
          // For contactless, use per-transaction limit if available, else fallback to daily
          payload.contactlessLimit = String(perVal || dailyVal);
          break;
        default:
          break;
      }
    });
    console.log(payload)
    const sendData = {
      userResponse: payload,
    };

    let inputString = "Proceed" + "<split>" + JSON.stringify(sendData);
    window["autosubmit"](inputString);

    //console.log(sendData)
  };
  handleCancel = () => {
    document.querySelector(".manage-credit-card-sf").style.pointerEvents =
      "none";
    document.querySelector(".manage-credit-card-sf").style.opacity = "0.8";

    let sendData = { userResponse: "Cancel" };
    let inputString = "Cancel" + "<split>" + JSON.stringify(sendData);
    window["autosubmit"](inputString);
    //console.log(sendData)
    this.restoreOriginalState(false);
  };
  render() {
    const totalCreditMax = Number(this.state.totalCreditMaxLimit || 0);
    const totalCreditCurrent = Number(this.state.totalCreditCurrentLimit || 0);
    const showTotalCredit = totalCreditMax > 0;
    const transactionModeLabel = this.props.transactionMode || "";
    const cardNumberLastFour = this.props.cardNumberLastFour || "";

    return (
      <MainWrapper className="manage-credit-card-sf disable-item">
        {showTotalCredit ? (
          <CardLimitSlider style={{ background: "#fff" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "12px",
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                Set Total Credit Limit
              </div>
              <div
                style={{
                  color: "#800000",
                  fontWeight: "bold",
                  fontSize: "13px",
                }}
              >
                ₹{this.formatAmount(totalCreditCurrent)}
              </div>
            </div>

            <div className="cardSliderContainer" style={{ margin: "4px 20px" }}>
              <label>
                <input
                  className="cardSlider"
                  // id="cardLimitRange"
                  type="range"
                  min={totalCreditMax === 0 ? 0 : 1}
                  max={totalCreditMax}
                  value={totalCreditCurrent}
                  onChange={(event) => {
                    this.handleTotalCreditSlider(event);
                  }}
                  step={1}
                />
              </label>
            </div>

            <div style={{ width: "244px", margin: "0px 20px" }}>
              {/* <div style={{display: "inline-block", padding: "5px 0 0 6px",fontSize:'12px'}}>
        ₹1
        </div> */}

              <div
                style={{
                  display: "inline-block",
                  float: "right",
                  padding: "5px 0 0 0",
                  fontSize: "12px",
                }}
              >
                ₹{this.formatAmount(totalCreditMax)}
              </div>

              <div
                style={{
                  fontSize: "12px",
                  width: "100%",
                  textAlign: "center",
                  padding: "16px 0px 20px 0px",
                }}
              >
                Current limit : ₹
                {this.formatAmount(this.props.currentCreditLimit || "0")}
              </div>
            </div>
          </CardLimitSlider>
        ) : null}
        {/* <div style={{ width: "100%", padding: "8px 0px 10px 0px" }}>
          You can set the controls for <b>{transactionModeLabel}</b>
          {cardNumberLastFour ? (
            <span>
              {" "}
              for your card <b>{cardNumberLastFour}</b>
            </span>
          ) : null}{" "}
          below:
        </div> */}
        <CardContainer>
          {this.state.cardData.map((data, index) => {
            const storedLimits = this.state.setLimits[index] || {};
            const hasDailyLimits = data.hasDailyLimits;
            const hasPerLimits = data.hasPerLimits;

            const resolvedDailySource = hasDailyLimits
              ? storedLimits.daily !== undefined && storedLimits.daily !== null
                ? storedLimits.daily
                : storedLimits.limit !== undefined && storedLimits.limit !== null
                ? storedLimits.limit
                : data.currentLimitDaily !== undefined && data.currentLimitDaily !== null
                ? data.currentLimitDaily
                : data.currentLimit !== undefined && data.currentLimit !== null
                ? data.currentLimit
                : data.maxLimit_Daily !== undefined && data.maxLimit_Daily !== null
                ? data.maxLimit_Daily
                : "0"
              : null;

            const resolvedPerSource = hasPerLimits
              ? storedLimits.per !== undefined && storedLimits.per !== null
                ? storedLimits.per
                : data.currentLimitPer !== undefined && data.currentLimitPer !== null
                ? data.currentLimitPer
                : data.maxLimit_Per !== undefined && data.maxLimit_Per !== null
                ? data.maxLimit_Per
                : data.maxLimit !== undefined && data.maxLimit !== null
                ? data.maxLimit
                : "0"
              : null;

            const resolvedDailyValue = hasDailyLimits
              ? String(resolvedDailySource)
              : null;
            const resolvedPerValue = hasPerLimits
              ? String(resolvedPerSource)
              : null;

            const limitEntry = {
              limit: hasDailyLimits ? resolvedDailyValue : null,
              daily: hasDailyLimits ? resolvedDailyValue : null,
              per: hasPerLimits ? resolvedPerValue : null,
            };

            let shouldRenderDaily = false;
            let dailySliderValue = "0";
            let dailySliderMin = 0;
            let dailySliderMax = 0;
            let formattedDailySliderValue = "0";
            let formattedDailyMin = "0";
            let formattedDailyMax = "0";
            let formattedDailyCurrent = "0";

            if (hasDailyLimits && limitEntry.daily !== null) {
              shouldRenderDaily = true;
              const dailyMin = this.parseNumeric(
                data.minLimit_Daily || data.minLimit || "0",
                0
              );
              const rawDailyMax = this.parseNumeric(
                data.maxLimit_Daily ||
                  data.currentLimitDaily ||
                  data.currentLimit ||
                  dailyMin,
                dailyMin
              );
              const dailyMax = rawDailyMax < dailyMin ? dailyMin : rawDailyMax;
              const dailyValue = this.clampValue(
                limitEntry.daily,
                dailyMin,
                dailyMax
              );
              formattedDailySliderValue = this.formatAmount(dailyValue);
              formattedDailyMin = this.formatAmount(dailyMin);
              formattedDailyMax = this.formatAmount(dailyMax);
              formattedDailyCurrent = this.formatAmount(
                this.parseNumeric(
                  data.originalCurrentLimitDaily ||
                    data.currentLimit ||
                    dailyValue,
                  dailyValue
                )
              );
              dailySliderValue = String(dailyValue);
              dailySliderMin = dailyMin;
              dailySliderMax = dailyMax;
            }

            const shouldRenderPer =
              hasPerLimits && limitEntry.per !== null;
            let perSliderValue = "0";
            let perSliderMin = 0;
            let perSliderMax = 0;
            let formattedPerSliderValue = "0";
            let formattedPerMin = "0";
            let formattedPerMax = "0";
            let formattedPerCurrent = "0";

            if (shouldRenderPer) {
              const perMin = this.parseNumeric(data.minLimit_Per || "0", 0);
              const rawPerMax = this.parseNumeric(
                data.maxLimit_Per || data.currentLimitPer || perMin,
                perMin
              );
              const perMax = rawPerMax < perMin ? perMin : rawPerMax;
              const perValue = this.clampValue(limitEntry.per, perMin, perMax);
              perSliderValue = String(perValue);
              perSliderMin = perMin;
              perSliderMax = perMax;
              formattedPerSliderValue = this.formatAmount(perValue);
              formattedPerMin = this.formatAmount(perMin);
              formattedPerMax = this.formatAmount(perMax);
              formattedPerCurrent = this.formatAmount(
                this.parseNumeric(
                  data.originalCurrentLimitPer || perValue,
                  perValue
                )
              );
            }

            return (
              <div
                key={index}
                style={{ borderBottom: "1px solid rgba(0,0,0,0.05)" }}
              >
                <CardWrapper key={data.cardId}>
                  <Title>
                    <CardTitle>{data.title}</CardTitle>
                    {/* <Tooltip><p style={{margin:'0',width:'15px',padding:'1px 1px',fontSize:'10px'}}>i</p><TooltipText style={{fontSize:"11px"}} >{data.tooltip_text}</TooltipText></Tooltip> */}
                  </Title>

                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <Toggle>
                      <SlaveInput
                        type="checkbox"
                        checked={data.toggle_status}
                        onChange={() => {
                          this.handleToggle(data.cardId);
                        }}
                      />
                      <Slider></Slider>
                    </Toggle>

                    <CardLimitAccordion
                      onClick={() => {
                        // data.toggle_status?
                        this.handleAccordionClickState(data.cardId);
                        // :null
                      }}
                    >
                      <div
                        className={`${
                          this.state.activeAccordian == data.cardId
                            ? // && data.toggle_status
                              "upArrow"
                            : "downArrow"
                        }`}
                        // style={{pointerEvents: `${data.toggle_status?"auto":"none"}`}}
                      />
                    </CardLimitAccordion>
                  </div>
                </CardWrapper>

                {/* Accordian */}

                <div>
                  {this.state.activeAccordian == data.cardId ? (
                    // && data.toggle_status
                    <CardLimitSlider>
                      {shouldRenderDaily ? (
                        <div
                          style={{
                            marginBottom: shouldRenderPer ? "16px" : "0px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "12px",
                            }}
                          >
                            <div
                              style={{ fontWeight: "bold", fontSize: "12px" }}
                            >
                              Daily Transaction limit
                            </div>
                            <div
                              style={{
                                color: "#800000",
                                fontWeight: "bold",
                                fontSize: "13px",
                              }}
                            >
                              ₹{formattedDailySliderValue}
                            </div>
                          </div>

                          <div className="cardSliderContainer">
                            <label>
                              <input
                                className="cardSlider"
                                style={
                                  data.toggle_status
                                    ? { pointerEvents: "auto" }
                                    : { pointerEvents: "none" }
                                }
                                type="range"
                                min={dailySliderMin}
                                max={dailySliderMax}
                                value={dailySliderValue}
                                onChange={(event) => {
                                  if (data.toggle_status) {
                                    this.handleCardLimitSlider(
                                      event,
                                      data.cardId,
                                      index,
                                      "daily"
                                    );
                                  }
                                }}
                                step={1}
                                disabled={!data.toggle_status}
                              />
                            </label>
                          </div>

                          <div style={{ width: "244px", margin: "0px 8px" }}>
                            <div
                              style={{
                                display: "inline-block",
                                padding: "5px 0 0 6px",
                                fontSize: "12px",
                              }}
                            >
                              ₹{formattedDailyMin}
                            </div>

                            <div
                              style={{
                                display: "inline-block",
                                float: "right",
                                padding: "5px 0 0 0",
                                fontSize: "12px",
                              }}
                            >
                              ₹{formattedDailyMax}
                            </div>

                            <div
                              style={{
                                fontSize: "12px",
                                width: "100%",
                                textAlign: "center",
                                padding: "16px 0px 20px 0px",
                              }}
                            >
                              Current limit : ₹{formattedDailyCurrent}
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {shouldRenderPer ? (
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "12px",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "bold",
                                fontSize: "12px",
                              }}
                            >
                              Per Transaction limit
                            </div>
                            <div
                              style={{
                                color: "#800000",
                                fontWeight: "bold",
                                fontSize: "13px",
                              }}
                            >
                              ₹{formattedPerSliderValue}
                            </div>
                          </div>

                          <div className="cardSliderContainer">
                            <label>
                              <input
                                className="cardSlider"
                                style={
                                  data.toggle_status
                                    ? { pointerEvents: "auto" }
                                    : { pointerEvents: "none" }
                                }
                                type="range"
                                min={perSliderMin}
                                max={perSliderMax}
                                value={perSliderValue}
                                onChange={(event) => {
                                  if (data.toggle_status) {
                                    this.handleCardLimitSlider(
                                      event,
                                      data.cardId,
                                      index,
                                      "per"
                                    );
                                  }
                                }}
                                step={1}
                                disabled={!data.toggle_status}
                              />
                            </label>
                          </div>

                          <div style={{ width: "244px", margin: "0px 8px" }}>
                            <div
                              style={{
                                display: "inline-block",
                                padding: "5px 0 0 6px",
                                fontSize: "12px",
                              }}
                            >
                              ₹{formattedPerMin}
                            </div>

                            <div
                              style={{
                                display: "inline-block",
                                float: "right",
                                padding: "5px 0 0 0",
                                fontSize: "12px",
                              }}
                            >
                              ₹{formattedPerMax}
                            </div>

                            <div
                              style={{
                                fontSize: "12px",
                                width: "100%",
                                textAlign: "center",
                                padding: "16px 0px 20px 0px",
                              }}
                            >
                              Current limit : ₹{formattedPerCurrent}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </CardLimitSlider>
                  ) : null}
                </div>
              </div>
            );
          })}

          {/* here reset setting  */}

          <div style={{ padding: "28px 0px 16px 0px" }}>
            <div
              className="resetStyle"
              style={{
                width: "100%",
                textAlign: "center",
                color: "#003E8d",
                fontSize: "13px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => this.handleResetSettings()}
            >
              RESET {this.state.transactionMode} SETTINGS
            </div>
            <div
              style={{
                width: "100%",
                fontSize: "12px",
                textAlign: "center",
                margin: "8px 0px",
              }}
            >
              This feature will reset the limits.
            </div>
          </div>
        </CardContainer>

        {/* this UI condition made false in handle function, in future may need  */}
        {this.state.showButton ? (
          <div className="action-elem" onClick={this.handleChanges}>
            Save Changes
          </div>
        ) : null}
        <div className="action-elem" onClick={this.handleCancel}>
          Cancel
        </div>
      </MainWrapper>
    );
  }
}

export default DebitCardSettings;
